// extracted by mini-css-extract-plugin
export default {"root":"PlasmicInvitedStatusCard_root__RJ3NL","text":"PlasmicInvitedStatusCard_text__Hcpv1"};